export const services = [
  {
    id: 1,
    title: "Dermal Fillers",
    description: "Restore volume and smooth wrinkles with premium dermal fillers. We use trusted brands including Juvederm, Teosyal, and Restylane for natural-looking results.",
    brands: ["Juvederm", "Teosyal", "Restylane", "Revolax"],
    icon: "Syringe"
  },
  {
    id: 2,
    title: "Anti-Wrinkle Injections",
    description: "Reduce fine lines and wrinkles with expert anti-wrinkle treatments using premium Botox and Allergan products for a refreshed appearance.",
    brands: ["Botox", "Allergan"],
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Lip Augmentation",
    description: "Enhance your lips with expert filler techniques using Revolax, Azzalure, Plenhyage, Jalupro, Profhilo, and Juvederm for beautifully plump, natural-looking results.",
    brands: ["Revolax", "Azzalure", "Plenhyage", "Jalupro", "Profhilo", "Juvederm"],
    icon: "Heart"
  },
  {
    id: 4,
    title: "Skin Rejuvenation",
    description: "Revitalize your skin with advanced treatments designed to improve texture, tone, and overall radiance using premium products.",
    brands: ["Teosyal", "Restylane"],
    icon: "Star"
  },
  {
    id: 5,
    title: "Facial Contouring",
    description: "Define and sculpt your facial features with expertly placed dermal fillers for enhanced bone structure and symmetry.",
    brands: ["Juvederm", "Restylane", "Revolax"],
    icon: "Smile"
  },
  {
    id: 7,
    title: "Micro Needling",
    description: "Stimulate natural collagen production and improve skin texture with advanced micro needling treatments for smoother, more youthful-looking skin.",
    brands: ["Teosyal", "Restylane"],
    icon: "Sparkles"
  },
  {
    id: 8,
    title: "Medical Grade Skin Peels",
    description: "Our medical-grade skin peels use clinically proven exfoliating acids to stimulate cell renewal, improve skin tone and texture, and address concerns such as pigmentation, acne, and fine lines.",
    brands: ["Allergan"],
    icon: "Star"
  },
  {
    id: 9,
    title: "Nasal Folds (Smile Lines)",
    description: "Soften deep smile lines from nose to mouth with precise filler placement using premium products for a naturally refreshed appearance.",
    brands: ["Juvederm", "Restylane", "Teosyal"],
    icon: "Smile"
  },
  {
    id: 10,
    title: "Marionette Lines",
    description: "Diminish lines that run from the corners of your mouth to your chin with expert filler techniques for a more youthful lower face.",
    brands: ["Juvederm", "Restylane", "Revolax"],
    icon: "Heart"
  },
  {
    id: 11,
    title: "Cheek / Jawline / Chin Augmentation",
    description: "Enhance facial structure and definition with strategic dermal filler placement to create balanced, sculpted features and improved facial harmony.",
    brands: ["Juvederm", "Restylane", "Revolax", "Teosyal"],
    icon: "User"
  },
  {
    id: 12,
    title: "Tear Troughs",
    description: "Reduce under-eye hollows and dark circles with specialized tear trough treatments for a refreshed, well-rested appearance.",
    brands: ["Restylane", "Teosyal"],
    icon: "Sparkles"
  },
  {
    id: 13,
    title: "Nose Liquid Rhinoplasty",
    description: "Reshape and refine your nose non-surgically with precise dermal filler techniques to create better balance and symmetry.",
    brands: ["Juvederm", "Restylane"],
    icon: "Syringe"
  },
  {
    id: 14,
    title: "Dissolve",
    description: "Safely reverse or adjust previous filler treatments with professional dissolving procedures for optimal results and peace of mind.",
    brands: ["Allergan"],
    icon: "Star"
  },
  {
    id: 15,
    title: "Profhilo",
    description: "Experience bio-remodeling treatment that hydrates and lifts skin from within, improving elasticity and reducing fine lines for natural rejuvenation.",
    brands: ["Profhilo"],
    icon: "Sparkles"
  },
  {
    id: 24,
    title: "Polynucleotides",
    description: "Advanced regenerative treatment using DNA-based molecules to stimulate tissue repair, improve skin quality, reduce fine lines, and enhance overall skin health from within.",
    brands: ["Nucleofill", "Plinest"],
    icon: "Star"
  },
  {
    id: 25,
    title: "Jawline Slimming (Masseter Reduction)",
    description: "Reduce jaw muscle size and create a slimmer, more feminine facial contour with targeted Botox injections to the masseter muscles for a refined V-shaped face.",
    brands: ["Botox", "Allergan"],
    icon: "User"
  },
  {
    id: 16,
    title: "Nefertiti Neck Lift",
    description: "Smooth and lift the neck area by targeting platysma bands with specialized Botox technique for a more defined jawline and elegant neck appearance.",
    brands: ["Botox", "Allergan"],
    icon: "User"
  },
  {
    id: 17,
    title: "Hyperhidrosis (Excessive Sweating)",
    description: "Reduce excessive sweating in underarms, hands, or feet with Botox treatments that provide long-lasting relief and confidence.",
    brands: ["Botox", "Allergan"],
    icon: "Sparkles"
  },
  {
    id: 18,
    title: "Bunny Lines",
    description: "Smooth the fine lines that appear on the sides of your nose when you scrunch your face with targeted anti-wrinkle treatments.",
    brands: ["Botox", "Allergan"],
    icon: "Smile"
  },
  {
    id: 19,
    title: "Down Turn Smile",
    description: "Lift downturned corners of the mouth for a more positive, youthful expression with precise Botox and filler combination treatments.",
    brands: ["Botox", "Juvederm"],
    icon: "Heart"
  },
  {
    id: 20,
    title: "Gummy Smile Correction",
    description: "Reduce excessive gum display when smiling with expert Botox placement for a more balanced, confident smile.",
    brands: ["Botox", "Allergan"],
    icon: "Smile"
  },
  {
    id: 21,
    title: "Pebbled Chin",
    description: "Smooth an irregular or dimpled chin appearance with Botox to relax overactive muscles for a smoother, more refined chin contour.",
    brands: ["Botox", "Allergan"],
    icon: "User"
  },
  {
    id: 22,
    title: "Perioral Lines",
    description: "Soften vertical lip lines around the mouth with a combination of anti-wrinkle treatments and fillers for smoother, younger-looking skin.",
    brands: ["Botox", "Juvederm", "Restylane"],
    icon: "Heart"
  },
  {
    id: 23,
    title: "Lip Flip",
    description: "Enhance your upper lip naturally by relaxing the muscles above the lip with Botox for a subtle, fuller appearance without fillers.",
    brands: ["Botox", "Allergan"],
    icon: "Heart"
  },
  {
    id: 26,
    title: "Vitamins (Biotin and B12)",
    description: "Boost your energy, metabolism, and overall wellness with vitamin injections. Biotin promotes healthy hair, skin, and nails, while B12 enhances energy levels and supports nervous system health.",
    brands: ["Vitamin Injections"],
    icon: "Sparkles"
  },
  {
    id: 27,
    title: "Fat Dissolving",
    description: "Target stubborn fat deposits in areas like double chin, jowls, and body contours with injectable fat dissolving treatments for a more sculpted, defined appearance without surgery.",
    brands: ["Aqualyx", "Lemon Bottle"],
    icon: "Syringe"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    text: "Angelina is absolutely amazing! Her attention to detail and gentle approach made me feel completely at ease. The results exceeded my expectations.",
    rating: 5,
    treatment: "Lip Augmentation"
  },
  {
    id: 2,
    name: "Emma Thompson",
    text: "I couldn't be happier with my anti-wrinkle treatment. Angelina's expertise really shows in the natural-looking results. Highly recommend!",
    rating: 5,
    treatment: "Anti-Wrinkle Injections"
  },
  {
    id: 3,
    name: "Jessica Williams",
    text: "Professional, skilled, and caring. Angelina took the time to understand exactly what I wanted and delivered perfect results. Thank you!",
    rating: 5,
    treatment: "Dermal Fillers"
  },
  {
    id: 4,
    name: "Rachel Green",
    text: "The best aesthetic practitioner in Hertfordshire! My skin has never looked better. I'll definitely be returning for more treatments.",
    rating: 5,
    treatment: "Skin Rejuvenation"
  }
];

export const galleryImages = [
  {
    id: 1,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/v0d4bkkw_AWA%20Client%20%236.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/v0d4bkkw_AWA%20Client%20%236.webp",
    title: "Lip Enhancement - Client #6"
  },
  {
    id: 2,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/yjc63tev_AWA%20Client%20%237.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/yjc63tev_AWA%20Client%20%237.webp",
    title: "Lip Enhancement - Client #7"
  },
  {
    id: 3,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/0e3r48df_AWA%20Client%20%239.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/0e3r48df_AWA%20Client%20%239.webp",
    title: "Lip Enhancement - Client #9"
  },
  {
    id: 4,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/uhajlvkn_AWA%20Client%20%2310.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/uhajlvkn_AWA%20Client%20%2310.webp",
    title: "Lip Enhancement - Client #10"
  },
  {
    id: 8,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/bla8rovl_IMG_20210523_141755.jpg",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/bla8rovl_IMG_20210523_141755.jpg",
    title: "Lip Filler Results"
  },
  {
    id: 9,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/16e2i9hj_Photo_1621778655582.jpg",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/16e2i9hj_Photo_1621778655582.jpg",
    title: "Beautiful Lip Enhancement"
  },
  {
    id: 10,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/88enyt9k_Photo_1621778457358.jpg",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/88enyt9k_Photo_1621778457358.jpg",
    title: "Gorgeous Lip Results"
  },
  {
    id: 5,
    category: "jawline",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/k9abkb69_AWA%20Client%20%238%20Jawline.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/k9abkb69_AWA%20Client%20%238%20Jawline.webp",
    title: "Jawline Enhancement - Client #8"
  },
  {
    id: 6,
    category: "jawline",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/xl6c9gmt_Photo_1621621186795.png",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/xl6c9gmt_Photo_1621621186795.png",
    title: "Jawline & Chin Definition"
  },
  {
    id: 7,
    category: "jawline",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/5k9a9qx2_IMG_20210521_193548_879.jpg",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/5k9a9qx2_IMG_20210521_193548_879.jpg",
    title: "Neck & Jawline Contouring"
  },
  {
    id: 11,
    category: "jawline",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/lw7o5f8g_Jawline.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/lw7o5f8g_Jawline.webp",
    title: "Jawline Sculpting Results"
  },
  {
    id: 12,
    category: "jawline",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/d8zb4a99_Jawline%20%232.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/d8zb4a99_Jawline%20%232.webp",
    title: "Neck & Jawline Enhancement"
  },
  {
    id: 13,
    category: "jawline",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/lr0qe7pv_Jawline%20%233.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/lr0qe7pv_Jawline%20%233.webp",
    title: "Jawline Contouring Treatment"
  },
  {
    id: 14,
    category: "wrinkles",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/iivhzv77_Wrinkles.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/iivhzv77_Wrinkles.webp",
    title: "Anti-Wrinkle Treatment Results"
  },
  {
    id: 15,
    category: "wrinkles",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/9wwjsy2w_Wrinkles%20%232.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/9wwjsy2w_Wrinkles%20%232.webp",
    title: "Forehead Wrinkle Reduction"
  },
  {
    id: 16,
    category: "fillers",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/fuin1a9h_Nose%20filler.webp",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/fuin1a9h_Nose%20filler.webp",
    title: "Nose Filler Enhancement"
  },
  {
    id: 17,
    category: "teartroughs",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/bzcjtw4u_Tear%20Troughs.jpeg",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/bzcjtw4u_Tear%20Troughs.jpeg",
    title: "Tear Trough Treatment"
  },
  {
    id: 18,
    category: "teartroughs",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/59xxfrd3_Tear%20Troughs%20%232.jpeg",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/59xxfrd3_Tear%20Troughs%20%232.jpeg",
    title: "Under Eye Rejuvenation"
  },
  {
    id: 19,
    category: "teartroughs",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/w2cn8gg5_Tear%20Troughs%20%233.jpeg",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/w2cn8gg5_Tear%20Troughs%20%233.jpeg",
    title: "Dark Circle Reduction"
  },
  {
    id: 20,
    category: "teartroughs",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/7pwhgxgy_Tear%20Troughs%20%234.jpeg",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/7pwhgxgy_Tear%20Troughs%20%234.jpeg",
    title: "Tear Trough Filler Results"
  },
  {
    id: 21,
    category: "teartroughs",
    before: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/wgzvo73w_Tear%20Troughs%20%235.jpeg",
    after: "https://customer-assets.emergentagent.com/job_c974e444-1b01-42b6-b195-4121c5fc3959/artifacts/wgzvo73w_Tear%20Troughs%20%235.jpeg",
    title: "Under Eye Enhancement"
  },
  {
    id: 22,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/bvejv5uk_Lip%20Filler.jpg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/bvejv5uk_Lip%20Filler.jpg",
    title: "Lip Filler Transformation"
  },
  {
    id: 23,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/41oi7juh_Lip%20Filler%20%232.jpg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/41oi7juh_Lip%20Filler%20%232.jpg",
    title: "Lip Enhancement Results"
  },
  {
    id: 24,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/p439h0hm_Lip%20Filler%20%233.jpg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/p439h0hm_Lip%20Filler%20%233.jpg",
    title: "Natural Lip Augmentation"
  },
  {
    id: 25,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/7bbfom71_Lip%20Filler%20%234.jpg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/7bbfom71_Lip%20Filler%20%234.jpg",
    title: "Beautiful Lip Definition"
  },
  {
    id: 26,
    category: "lips",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/wvknoy96_Lip%20Filler%20%235.jpg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/wvknoy96_Lip%20Filler%20%235.jpg",
    title: "Stunning Lip Enhancement"
  },
  {
    id: 27,
    category: "chinfiller",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/8q6oyc0d_Chin%20Filler.jpeg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/8q6oyc0d_Chin%20Filler.jpeg",
    title: "Chin Filler Results"
  },
  {
    id: 28,
    category: "chinfiller",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/j601p76w_Chin%20Filler%20%232.jpeg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/j601p76w_Chin%20Filler%20%232.jpeg",
    title: "Chin Definition Enhancement"
  },
  {
    id: 29,
    category: "chinfiller",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/icprk4sq_Chin%20Filler%20%233.jpeg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/icprk4sq_Chin%20Filler%20%233.jpeg",
    title: "Chin Augmentation Results"
  },
  {
    id: 30,
    category: "facerejuvenation",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/ti75j4o5_Face%20Rejuvenation.jpeg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/ti75j4o5_Face%20Rejuvenation.jpeg",
    title: "Face Rejuvenation Results"
  },
  {
    id: 31,
    category: "facerejuvenation",
    before: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/7jcz3b1w_Face%20Rejuvenation%20%232.jpeg",
    after: "https://customer-assets.emergentagent.com/job_ce62a7e3-2ac3-46b7-8812-81734a0e5711/artifacts/7jcz3b1w_Face%20Rejuvenation%20%232.jpeg",
    title: "Full Face Rejuvenation"
  }
];

export const priceList = [
  { treatment: "Microneedling - Single Session", price: "£120" },
  { treatment: "Microneedling - Course of 3", price: "£300 (£100 per session)" },
  { treatment: "Microneedling - Course of 6", price: "£540 (£90 per session)" },
  { treatment: "Medical-Grade Skin Peels - Single Session", price: "£85" },
  { treatment: "Medical-Grade Skin Peels - Course of 3", price: "£225 (£75 per session)" },
  { treatment: "Medical-Grade Skin Peels - Course of 6", price: "£420 (£70 per session)" },
  { treatment: "Lip Filler - 0.5ml", price: "£140" },
  { treatment: "Lip Filler - 0.75ml", price: "£160" },
  { treatment: "Lip Filler - 1ml", price: "£180" },
  { treatment: "Nasal Folds (Smile Lines) - 1ml", price: "£160" },
  { treatment: "Marionette Lines - 1ml", price: "£160" },
  { treatment: "Cheek Augmentation - 1ml", price: "£160" },
  { treatment: "Cheek Augmentation - 2ml", price: "£250" },
  { treatment: "Jawline Augmentation - 1ml", price: "£160" },
  { treatment: "Jawline Augmentation - 2ml", price: "£250" },
  { treatment: "Chin Augmentation - 1ml", price: "£140" },
  { treatment: "Chin Augmentation - 2ml", price: "£200" },
  { treatment: "Tear Troughs", price: "£200" },
  { treatment: "Nose Liquid Rhinoplasty", price: "£180" },
  { treatment: "Filler Dissolve", price: "£130" },
  { treatment: "Profhilo - 1st Session Skin Booster", price: "£210" },
  { treatment: "Profhilo - 2nd Session (4 weeks) Skin Booster", price: "£190" },
  { treatment: "Redensity 1 - Skin Booster - 1st Session", price: "£160" },
  { treatment: "Redensity 1 - Skin Booster - 2nd Session", price: "£140" },
  { treatment: "Polynucleotides - Single Session", price: "£180" },
  { treatment: "Polynucleotides - Course of 3", price: "£450 (£150 per session)" },
  { treatment: "Polynucleotides Eyes - Single Session", price: "£150" },
  { treatment: "Polynucleotides Eyes - Course of 3", price: "£390 (£130 per session)" },
  { treatment: "Anti-Wrinkles (Botox) - 1 Area", price: "£150" },
  { treatment: "Anti-Wrinkles (Botox) - 2 Areas", price: "£190" },
  { treatment: "Anti-Wrinkles (Botox) - 3 Areas", price: "£230" },
  { treatment: "Anti-Wrinkles (Botox) - 4 Areas", price: "£260" },
  { treatment: "Down-Turned Smile", price: "£70" },
  { treatment: "Gummy Smile Correction", price: "£70" },
  { treatment: "Pebbled Chin (Orange Skin)", price: "£70" },
  { treatment: "Perioral Lines (Smoker's Lines)", price: "£70" },
  { treatment: "Lip Flip", price: "£60" },
  { treatment: "Bunny Lines", price: "£60" },
  { treatment: "Jawline Slimming (Masseter Reduction)", price: "£150" },
  { treatment: "Nefertiti Neck Lift (Platysma Bands)", price: "£180" },
  { treatment: "Hyperhidrosis (Excessive Sweating)", price: "£280" },
  { treatment: "Male Anti-Wrinkles - Additional Product", price: "+£60" },
  { treatment: "Biotin - Single Session", price: "£30" },
  { treatment: "Biotin - Course of 6", price: "£120 (£20 per session)" },
  { treatment: "B12 - Single Session", price: "£30" },
  { treatment: "B12 - Course of 4", price: "£100 (£25 per session)" },
  { treatment: "B12 - Course of 6", price: "£120 (£20 per session)" },
  { treatment: "Fat Dissolving - Small Area", price: "£100" },
  { treatment: "Fat Dissolving - Medium Area", price: "£150" },
  { treatment: "Fat Dissolving - Large Area", price: "£200" },
  { treatment: "Package: Dissolve & Refill Lips", price: "£250" },
  { treatment: "Package: 2ml", price: "£250" },
  { treatment: "Package: 3ml", price: "£340" },
  { treatment: "Package: 4ml", price: "£430" },
  { treatment: "Package: 5ml", price: "£520" },
  { treatment: "Package: 6ml", price: "£610" },
  { treatment: "Consultation", price: "Free" }
];